import React from 'react'

import profilePic from './avatar.jpg'
import { rhythm } from '../../utils/typography'

const Bio = () => (
  <div
    css={{
      marginTop: rhythm(1)
    }}>
    <div
      css={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: rhythm(1)
      }}>
      <img
        src={profilePic}
        style={{
          borderRadius: '100%',
          marginBottom: 0,
          width: rhythm(3),
          height: rhythm(3)
        }}
      />
    </div>
    <div css={{ backgroundColor: 'rgba(0,0,0,0.04)', padding: rhythm(1) }}>
      <p>
        My name is Albert Casanovas and I'm a passionate full-stack developer
        based in Barcelona. I build software for today's users and tomorrow's
        platforms.
      </p>
      <p css={{ marginBottom: 0 }}>
        <a href="mailto:hello@albertdev.com">Mail</a>{' '}
        <a target="_blank" href="https://git.albertdev.com/explore/projects">
          Gitlab
        </a>{' '}
        <a target="_blank" href="https://albertdev.com/cv.pdf">
          CV
        </a>
      </p>
    </div>
  </div>
)

export default Bio



// WEBPACK FOOTER //
// ./src/components/Bio/Bio.js